/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "./Orders.css";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import { useLocation } from "react-router-dom";
import {
  setDoc,
  doc,
  updateDoc,
  arrayUnion,
  arrayRemove,
  writeBatch,
  serverTimestamp,
} from "firebase/firestore";
import { useTranslation } from "react-i18next";
import ModalAdd from "../../components/orders/model/ModelAdd";

import { db } from "../../firebase";
import {
  Menu,
  Dropdown,
  Button,
  message,
  Space,
  InputNumber,
  Radio,
  Timeline,
} from "antd";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import { datat } from "../../components/orders/DataTableTemplatingDemo/data";
import { format } from "date-fns";
import Swal from "sweetalert2";
import freeCountries from "../../utils/freeCountries.json";

function OrderDetailsabndn() {
  const { t, i18n } = useTranslation();
  const store = useSelector((state) => state.StoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  const isFreeCountry = freeCountries.includes(account?.country);
  const [showSideBar, setShowSideBar] = useState(true);
  const productdata = useSelector((state) => state.ProductsReducer);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const location = useLocation();
  const { from = "N/A", products = [] } = location.state || {};

  const data = useSelector((state) =>
    state.OrdersReducer.find((order) => order.id === from.id)
  );
  const [showModal, setShowModal] = useState(false);
  const [dataForm, setDataForm] = useState({
    user: account?.user,
    productId: "",
    name: "",
    phone: "",
    state: "",
    paid: "0",
    address: "",
    commune: "",
    deleveryStatus: "1",
    stopdeskDelivery: false,
    deleveryPrice: 0,
    products: [],
    deliveryPrice: 0,
    qty: "",
    total: 0,
    options: "",
    paymentType: t("orders.cash_on_delivery"),
    timeStamp: serverTimestamp(),
  });

  const handleUpdate = async (orderData) => {
    if (!orderData || orderData.isValid) return;
    setDataForm(orderData);
    setShowModal(true);
  };

  const statusOptions = {
    1: "جديد",
    3: "مؤكدة",
    "11-2": "لم يرد على الاتصال",
    "11-3": "مؤجلة",
    6: "ملغي",
    "11-5": "ملغى من قبل العميل",
    "11-1": "انتظار اتصال العميل",
    "11-4": "الخط مغلق",
    4: "رفع لشركة التوصيل",
    5: "مكتملة",
  };
  const currencyMap = {
    دج: {
      ar: "دج",
      fr: "DA",
      en: "DZD",
    },
  };
  const localizedCurrency =
    currencyMap[store.currencySymbol]?.[i18n.language] || store.currencySymbol;
  const getStatusText = (status) => {
    return statusOptions[status] || "";
  };

  const formatTimestamp = (rowData) => {
    if (rowData.timestamp) {
      const date = rowData.timestamp.toDate();
      return date.toLocaleString(); // تنسيق الوقت والتاريخ حسب اللغة والتوقيت المحلي
    }
    return "";
  };

  // دالة لتقليل النص وإضافة النقاط الثلاث إذا كان أطول من الحد الأقصى
  const maxChars = 25;
  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength - 3) + "...";
    }
    return text;
  };

  const changeShip = async (data, status) => {
    if (status === "1") {
      axios
        .post(
          url,
          {
            source: 4,
            destination_text: from.address,
            product_price: `${from.total - from.deleveryPrice}`,
            customer_name: from.name,
            customer_phone: from.phone,
            express: false,
            wilaya: datat.filter((d) => d.wilaya_name === from.state)[0].fields
              .wilaya,
            commune: parseInt(
              datat.filter((d) => d.commune_name === from.commune)[0].pk
            ),
            note_to_driver: from.options,
            products: [
              {
                product_id: from.sku,
                logistical_description: productdata.filter(
                  (product) => product.id === from.productId
                )[0].name,
                quantity: from.qty,
              },
            ],
          },
          {
            headers: {
              Authorization: `Token ${store.Maystro}`,
            },
          }
        )

        .then((response) => {
          setDoc(doc(db, "orders", from.id), { ...data, DC: status });
          changeStatus(rowData, "4");
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: t("ui.sendOrderFailed"),
            text: t("ui.checkOrderDetails"),
            confirmButtonText: t("adduser.ok"),
            confirmButtonColor: "rgb(141, 93, 167)",
          });
        });
    } else if (status === "2") {
      axios
        .post(
          url1,
          {
            source: 1,
            TypeLivraision: 1,
            Echange: 0,
            produit: `${
              productdata.filter((product) => product.id === from.productId)[0]
                .name
            } × ${data.qty}`,
            Consomateur: from.name,
            Mobile_1: from.phone,
            Mobile_2: from.phone,
            Adresse: from.address,
            CodeWilaya: datat.filter((d) => d.wilaya_name === from.state)[0]
              .fields.wilaya,
            Commune: datat.filter((d) => d.commune_name === from.commune)[0]
              .commune_name_ascii,
            Total: from.total,
            NoteClient: from.options,
            Remboursement: 0,
          },
          {
            headers: {
              KeyUnique: `${store.Zrexpress}`,
            },
          }
        )
        .then((response) => {
          setDoc(doc(db, "orders", from.id), { ...data, DC: status });
          changeStatus(rowData, "4");
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: t("ui.sendOrderFailed"),
            text: t("ui.checkOrderDetails"),
            confirmButtonText: t("adduser.ok"),
            confirmButtonColor: "rgb(141, 93, 167)",
          });
        });
    } else if (status === "4") {
      axios
        .post(url4, {
          user_guid: `${store.Userguid}`,
          api_token: `${store.ApitokenNord}`,
          type_id: 1,
          stop_desk: 0,
          stop_desk: 0,
          produit: `${
            productdata.filter((product) => product.id === from.productId)[0]
              .name
          } × ${from.qty}`,
          client: from.name,
          phone: from.phone,
          quantite: from.qty,
          adresse: from.address,
          wilaya_id: datat.filter((d) => d.wilaya_name === from.state)[0].fields
            .wilaya,
          commune: datat.filter((d) => d.commune_name === from.commune)[0]
            .commune_name_ascii,
          montant: from.total,
          NoteClient: from.options,
          Remboursement: 0,
          poids: `0`,
        })
        .then((response) => {
          setDoc(doc(db, "orders", from.id), { ...data, DC: status });
          changeStatus(rowData, "4");
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: t("ui.sendOrderFailed"),
            text: t("ui.checkOrderDetails"),
            confirmButtonText: t("adduser.ok"),
            confirmButtonColor: "rgb(141, 93, 167)",
          });
        });
    } else if (status === "3") {
      axios
        .post(
          `${store.Uecotrack}/api/v1/create/order?api_token=${
            store.Ecotrack
          }&reference&nom_client=${from.name}&telephone=${
            from.phone
          }&telephone_2=${from.phone}&adresse=${
            from.address
          }&code_postal&commune=${
            datat.filter((d) => d.commune_name === from.commune)[0]
              .commune_name_ascii
          }&code_wilaya=${
            datat.filter((d) => d.wilaya_name === from.state)[0].fields.wilaya
          }&montant=${from.total}&remarque=${from.options}&produit=${
            productdata.filter((product) => product.id === from.productId)[0]
              .name
          } × ${from.qty}&stock&quantite=${
            from.qty
          }&produit_a_recupere&boutique&type=1&stop_desk`
        )
        .then((response) => {
          if (response.status === 200) {
            setDoc(doc(db, "orders", from.id), { ...data, DC: status });
            changeStatus(rowData, "4");
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: t("ui.sendOrderFailed"),
            text: t("ui.checkOrderDetails"),
            confirmButtonText: t("adduser.ok"),
            confirmButtonColor: "rgb(141, 93, 167)",
          });
        });
    } else {
      await setDoc(doc(db, "orders", from.id), { ...data, DC: status });
      changeStatus(rowData, "4");
    }
  };

  const shipActionTemplate = (rowData) => {
    const handleUpload = () => {
      // تنفيذ الرفع لشركة التوصيل هنا
    };

    const menu = (
      <Menu className="right-to-left">
        {!rowData.isValid && (
          <>
            {!!store.Maystro && (
              <Menu.Item
                key="1"
                className="ms-33 ss bi bi-pencil-fill"
                size={16}
              >
                <span onClick={() => handleUpload(1)}>Maystro</span>
              </Menu.Item>
            )}
            {!!store.Zrexpress && (
              <Menu.Item
                key="2"
                className="ms-33 ss bi bi-pencil-fill"
                size={16}
              >
                <span onClick={() => handleUpload(2)}>{t("zr_express")}</span>
              </Menu.Item>
            )}
            {!!store.Ecotrack && !!store.Uecotrack && (
              <Menu.Item
                key="3"
                className="ms-33 ss bi bi-pencil-fill"
                size={16}
              >
                <span onClick={() => handleUpload(3)}>{t("services.foorCall.companies.ecotrack")}</span>
              </Menu.Item>
            )}
            {!!store.Userguid && !!store.ApitokenNord && (
              <Menu.Item
                key="4"
                className="ms-33 ss bi bi-pencil-fill"
                size={16}
              >
                <span onClick={() => handleUpload(4)}>Nord Et Ouest</span>
              </Menu.Item>
            )}
          </>
        )}
      </Menu>
    );

    return (
      <Dropdown overlay={menu}>
        <Button
          type="primary"
          size="small"
          className="hp-bg-black-100 hp-border-color-black-100 hp-hover-bg-black-80 hp-hover-border-color-black-80"
        >
          {t("ui.actions")}
        </Button>
      </Dropdown>
    );
  };

  const changeStatus = async (data, status, from) => {
    const currentTime = new Date();
    const updatedStatusTimeline = [
      ...(data.statusTimeline || []),
      { status, timestamp: currentTime },
    ];
    const telegramBotToken = "6672968395:AAHFokejZq4r6GRRDHlm2FDqXk0-pXoQmOs";
    const chatId = store.Idtelegram;
    const truncatedProductName = truncateText(
      from.nameproduct ? from.nameproduct : selectedProduct.name,
      maxChars
    );
    const statusMessages = {};

    if (store.done === true) {
      statusMessages["5"] = `✅ تم إتمام الطلب بنجاح! ✅\n\n👤 العميل: ${
        data.name ? data.name : ""
      }\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${
        data.state
      }\n🛍 المنتج: ${truncatedProductName}\n\nنود إبلاغكم بأنه تم إتمام الطلب بنجاح. يمكنكم متابعة تفاصيل وضعية الطلب وموعد التسليم عبر البوابة الخاصة بكم. شكرًا لتفهمكم وثقتكم في خدماتنا.`;
    }
    const statusMessagess = {};

    if (store.termine === true) {
      statusMessagess["11-2"] = `📢 طلب لم يرد على الاتصال! 📢\n\n👤 العميل: ${
        data.name ? data.name : ""
      }\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${
        data.state
      }\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: "لم يرد على الاتصال". نقترح محاولة الاتصال مع العميل لاحقًا لتأكيد التفاصيل. شكرًا لك على تفانيك في تقديم خدمة عالية الجودة.`;
      statusMessagess["11-3"] = `📢 طلب مؤجل! 📢\n\n👤 العميل: ${
        data.name ? data.name : ""
      }\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${
        data.state
      }\n🛍 المنتج: ${truncatedProductName}\n\nتم تأجيل تسليم الطلب إلى وقت لاحق. ننصح بجدولة الاتصال بالعميل لترتيب تفاصيل موعد التسليم المناسب. نقدر جهودك في تقديم الخدمة المميزة.`;
      statusMessagess["11-5"] = `📢 إلغاء طلب! 📢\n\n👤 العميل: ${
        data.name ? data.name : ""
      }\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${
        data.state
      }\n🛍 المنتج: ${truncatedProductName}\n\nتم إلغاء الطلب من قبل العميل. يُرجى ترتيب إجراءات الإلغاء ومتابعة الإجراءات المناسبة. نشكرك على تفهمك واهتمامك برضاء العملاء.`;
      statusMessagess["11-1"] = `📢 انتضار اتصال العميل ! 📢\n\n👤 العميل: ${
        data.name ? data.name : ""
      }\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${
        data.state
      }\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: "انتظار اتصال العميل". يُرجى محاولة التواصل مع العميل بأسرع وقت ممكن لتأكيد التفاصيل وترتيب التسليم المناسب. شكرًا لك على اهتمامك بتقديم الخدمة الفائقة.`;
      statusMessagess["11-4"] = `📢 طلب خط مغلق! 📢\n\n👤 العميل: ${
        data.name ? data.name : ""
      }\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${
        data.state
      }\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: "الخط مغلق". نود إبلاغك بأن العميل قد يكون غير متاح حاليًا. ننصح بمحاولة الاتصال في وقت لاحق أو ترتيب وقت مناسب للتواصل. نشكرك على جهودك في تقديم أفضل خدمة للعملاء.`;
    }

    const statusMessagees = {};

    if (store.confrim === true) {
      statusMessagees["3"] = `📢 طلب مؤكد! 📢\n\n👤 العميل: ${
        data.name ? data.name : ""
      }\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${
        data.state
      }\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: "مؤكدة". ننصح برفع الطلب في شركة التوصيل لبدء إجراءات التوصيل. شكرًا لك على جهودك في تقديم أفضل تجربة للعميل وتسهيل عملية التسليم.`;
    }

    const statusMessageesNew = {};

    if (store.new === true) {
      statusMessageesNew["1"] = `📢 تحديث حالة الطلب! 📢\n\n👤 العميل: ${
        data.name ? data.name : ""
      }\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${
        data.state
      }\n🛍 المنتج: ${truncatedProductName}\n\nلدينا تحديث جديد على حالة الطلب. يُرجى تأكيد ومتابعة الحالة الجديدة في أقرب وقت ممكن. شكرًا لك على اهتمامك بتقديم خدمة مميزة وتلبية احتياجات العملاء بكل دقة وسرعة.`;
    }

    const statusMessagessDD = {};

    if (store.delevery === true) {
      statusMessagessDD[
        "4"
      ] = `🚚 طلب تم رفعه لشركة التوصيل! 🚚\n\n👤 العميل: ${
        data.name ? data.name : ""
      }\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${
        data.state
      }\n🛍 المنتج: ${truncatedProductName}\n\nنود إعلامك بأنه تم رفع الطلب لشركة التوصيل بنجاح. يتم الآن التنسيق لبدء عملية التسليم. نشكرك على جهودك واهتمامك بتقديم تجربة مميزة للعميل.`;
    }
    const statusMessagessCC = {};

    if (store.cancel === true) {
      statusMessagessDD["6"] = `❌ تم الغاء الطلب! ❌\n\n👤 العميل: ${
        data.name ? data.name : ""
      }\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${
        data.state
      }\n🛍 المنتج: ${truncatedProductName}\n\nنأسف لإبلاغكم بأن العميل قام بإلغاء الطلب. تم تحديث حالة الطلب بنجاح. شكرًا على جهودك في تقديم الخدمة ونأمل في تقديم تجربة أفضل في المستقبل.`;
    }
    const message =
      statusMessages[status] ||
      statusMessagees[status] ||
      statusMessagessCC[status] ||
      statusMessageesNew[status] ||
      statusMessagessDD[status] ||
      statusMessagess[status];
    const messageC = `📵 حالة الطلب غير مكتملة! 📵\n\n👤 العميل: ${
      data.name ? data.name : ""
    }\n📞 الهاتف: ********\n🌍 الولاية: ${
      data.state
    }\n🛍 المنتج: ${truncatedProductName}\n\nنرجو إعلامك بأن رقم هاتف الطلب غير ظاهر بسبب عدم توفر رصيد كافي أو عدم تفعيل باقتك في فوورويب . يُرجى التحقق من حالة رصيدك وتفعيل الباقة لتتمكن من متابعة تفاصيل طلبك بشكل كامل. شكرًا على تفهمك ونتطلع لخدمتك بشكل أفضل.`;

    await setDoc(doc(db, "orders", data.id), {
      ...data,
      deleveryStatus: status,
      statusTimeline: updatedStatusTimeline,
    });

    {
      data.isValid
        ? axios
            .post(
              `https://api.telegram.org/bot${telegramBotToken}/sendMessage`,
              {
                chat_id: chatId,
                text: messageC,
              }
            )
            .then((response) => {
              console.log("تم إرسال الإشعار بنجاح");
            })
            .catch((error) => {
              console.error("حدث خطأ أثناء إرسال الإشعار", error);
            })
        : axios
            .post(
              `https://api.telegram.org/bot${telegramBotToken}/sendMessage`,
              {
                chat_id: chatId,
                text: message,
              }
            )
            .then((response) => {
              console.log("تم إرسال الإشعار بنجاح");
            })
            .catch((error) => {
              console.error("حدث خطأ أثناء إرسال الإشعار", error);
            });
    }
  };

  const changepaid = async (data, status) => {
    await setDoc(doc(db, "orders", data.id), { ...data, paid: status });
  };
  const phoneNumber = from.phone;
  const message = `thank you`;

  const handleCallButtonClick = () => {
    window.open(`tel:${phoneNumber}`);
  };

  {
    /* const handleTextButtonClick = () => {
        window.open(`sms:${phoneNumber}?body=${message}`);
    };*/
  }
  const [showOptions, setShowOptions] = useState(false);
  const handleButtonClick = () => {
    setShowOptions(!showOptions); // تغيير حالة الإظهار عند النقر
  };
  const defaultImage =
    "https://cdn-icons-png.flaticon.com/512/10608/10608900.png";

  let buttonImage = defaultImage;
  let buttonImage2 = defaultImage;

  switch (data?.deleveryStatus) {
    case "1":
      buttonImage = "https://cdn-icons-png.flaticon.com/512/10608/10608900.png";
      buttonImage2 =
        "https://cdn-icons-png.flaticon.com/512/10608/10608900.png";
      break;
    case "2":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/1688/1688988.png";
      buttonImage2 =
        "https://img.freepik.com/free-psd/delivery-box-isometric-3d-render-icon_47987-7574.jpg";
      break;
    case "3":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/8888/8888205.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/8888/8888205.png";
      break;
    case "4":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/1559/1559859.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/1559/1559859.png";
      break;
    case "5":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/6815/6815043.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/6815/6815043.png";
      break;
    case "6":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/391/391247.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/391/391247.png";
      break;
    case "11-1":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/2593/2593514.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/2593/2593514.png";
      break;
    case "11-2":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/9946/9946401.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/9946/9946401.png";
      break;
    case "11-3":
      buttonImage = "../agenda.png";
      buttonImage2 = "../agenda.png";
      break;
    case "11-4":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/8402/8402548.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/8402/8402548.png";
      break;
    case "11-5":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/7787/7787073.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/7787/7787073.png";
      break;
    default:
      buttonImage = defaultImage;
      buttonImage2 = defaultImage;
  }

  const dateBodyTemplate = (rowData) => {
    const date = new Date(rowData.timeStamp.seconds * 1000);
    return <span>{date.toLocaleString().toString()}</span>;
  };

  const selectedProduct = (() => {
    if (!from.id) {
      const product = products.filter((p) => p.id === from.productId)[0];

      return {
        ...from,
        orderQty: from.qty,
        price: from.deleveryPrice,
        ...product,
      };
    }
  })();
  if (from.nameproduct) {
    selectedProduct;
  }
  const [mode, setMode] = useState("left");

  const onChange = (e) => {
    setMode(e.target.value);
  };
  const messagesByStatus = {
    1: ``,
    2: "  ",
    3: `مرحباً ${data.name ? data.name : ""},\nتم تأكيد طلبك بنجاح .🛍 المنتج: ${
      data.nameproduct
    }\n💰إجمالي السعر: ${
      data.total
    } ${localizedCurrency}\nسيتم تجهيز طلبك وإرساله في أقرب وقت.شكرا لثقتك. لا تتردد في التواصل إذا كان لديك أي استفسارات.\nبانتظار خدمتك مجدداً،\n `,
    4: `مرحباً ${
      data.name ? data.name : ""
    },\nنود أن نعلمك أنه تم رفع طلبك لشركة التوصيل \n-🛍 المنتج: ${
      data.nameproduct
    }\n- 💰إجمالي السعر: ${
      data.total
    } ${localizedCurrency} \n  سيتصل بك الموزع خلال أيام ٫نرجو الاستعداد لاستلام المنتج والرد بسرعة. نقدر تفهمك وتعاونك، ونسعى دائمًا لخدمتك بشكل مميز `,
    5: ``,
    6: ` مرحباً ${
      data.name ? data.name : ""
    },\nنأسف لإبلاغك بأن طلبك قد تم إلغاؤه و السبب راجع لعدم ردك على إتصالاتنا .\n-🛍 المنتج: ${
      data.nameproduct
    }\n- 💰إجمالي السعر: ${
      data.total
    } ${localizedCurrency}\n إذا كنت مهتم لا تتردد في الاتصال بنا .\nبانتظار إتصالك `,
    "11-1": ` مرحباً ${
      data.name ? data.name : ""
    },\nنحن في انتظار اتصالك لتأكيد طلبك .\n-🛍 المنتج: ${
      data.nameproduct
    }\n- 💰إجمالي السعر: ${
      data.total
    }${localizedCurrency}\n    نود إعلامك أن الكمية المتاحة من المنتج قد تقترب من النفاذ. ننتظر اتصالك في أقرب وقت لتأكيد طلبك وضمان توفر المنتج لك\nطاب يومك,`,
    "11-2": `مرحباً ${
      data.name ? data.name : ""
    },\nنأسف لعدم الرد على اتصالنا السابق.\nيرجى الاتصال  بنا لتأكيد طلبك:\n-🛍 المنتج: ${
      data.nameproduct
    }\n- 💰إجمالي السعر: ${
      data.total
    } ${localizedCurrency}\nبإنتظار تواصلك لتأكيد طلبك ،\n`,
    "11-3": ` مرحباً ${
      data.name ? data.name : ""
    },\nنود إعلامك بأنه تم تأجيل طلبك:\n-🛍 المنتج: ${
      data.nameproduct
    }\n- 💰إجمالي السعر: ${
      data.total
    } ${localizedCurrency}\nسنتواصل معك قريبا لتحديد موعد الإستلام ،\n`,
    "11-4": `مرحباً ${
      data.name ? data.name : ""
    },\n لقد قمنا بمحاولة الاتصال بك لتأكيد طلبك، ولكن وجدنا خطك مغلقًا\n-🛍 المنتج: ${
      data.nameproduct
    }\n- 💰إجمالي السعر: ${
      data.total
    } ${localizedCurrency} \n   يُرجى التأكد من تفعيل الاتصال و ننتظر اتصالك في أقرب وقت لتأكيد طلبك وضمان توفر المنتج لك \n طاب يومك,`,
    "11-5": ` مرحباً ${
      data.name ? data.name : ""
    },\nنأسف لإلغاء طلبك .\n-🛍 المنتج: ${data.nameproduct}\n- 💰إجمالي السعر: ${
      data.total
    } ${localizedCurrency} \n إذا قررت طلب المنتج في وقت لاحق، فلا تتردد في الاتصال بنا. سنكون سعداء بخدمتك في المستقبل,`,
  };
  const currentUrl = account.store;
  const subdomain = currentUrl.split(".")[0];
  const subdomainWithoutProtocol = subdomain.replace(/(^\w+:|^)\/\//, "");
  const linktrack = `https://${subdomainWithoutProtocol}.foorweb.store/thanks/${data.phone}`;
  const messagePhone = phoneNumber;
  const messagePhontrack = ` مرحباً ${
    data.name ? data.name : ""
  },\n شحنتك في الطريق 🚚✨ اضغط على الرابط لتتبعها والاطمئنان!\n ${linktrack} `;
  const handleTextButtonClick = () => {
    const message = messagesByStatus[data?.deleveryStatus];
    window.open(`sms:${messagePhone}?body=${encodeURIComponent(message)}`);
  };
  const handleTextButtontrack = () => {
    window.open(
      `sms:${messagePhone}?body=${encodeURIComponent(messagePhontrack)}`
    );
  };
  // في نهاية معالجة حالة الطلب
  const handleStatusChangeButtonClick = () => {
    setShowOptions(!showOptions);

    const message = messagesByStatus[data?.deleveryStatus];
    setMessage(message); // تحديث نص الرسالة
  };

  const timestamp = from.timeStamp;
  const date = new Date(timestamp.seconds * 1000);
  const formattedDate = date.toLocaleString(); // يمكن استبدال 'ar-EG' بلغة ورمز توقيت المنطقة المحددة

  const combinedTemplate = (rowData) => {
    const statusColor = statusBodyTemplate(rowData);

    let buttonImage =
      "https://cdn-icons-png.flaticon.com/512/10608/10608900.png"; // الصورة الافتراضية

    if (
      rowdata?.deleveryStatus === "1" ? rowdata?.deleveryStatus === "1" : "1"
    ) {
      buttonImage = "https://cdn-icons-png.flaticon.com/512/10608/10608900.png";
    } else if (rowdata?.deleveryStatus === "2") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/1688/1688988.png";
    } else if (rowdata?.deleveryStatus === "3") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/8888/8888205.png";
    } else if (rowdata?.deleveryStatus === "4") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/1559/1559859.png";
    } else if (rowdata?.deleveryStatus === "5") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/6815/6815043.png";
    } else if (rowdata?.deleveryStatus === "6") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/391/391247.png";
    } else if (rowdata?.deleveryStatus === "11-1") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/2593/2593514.png";
    } else if (rowdata?.deleveryStatus === "11-2") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/9946/9946401.png";

      // إذا تم اختيار إرسال إلى شركة الشحن
      if (rowData.DC === "1") {
        buttonImage = "https://cdn-icons-png.flaticon.com/128/9946/9946401.png"; // استبدلها بمسار الصورة الخاصة بشركة الشحن المناسبة
      }
    } else if (rowdata?.deleveryStatus === "11-3") {
      buttonImage = "../agenda.png"; // يجب استبدالها بالمسار الصحيح للصورة
    } else if (rowdata?.deleveryStatus === "11-4") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/8402/8402548.png";
    } else if (rowdata?.deleveryStatus === "11-5") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/7787/7787073.png";
    }

    const shippingOptions = [];
    if (!!store.Maystro) shippingOptions.push({ value: "1", label: "Maystro" });
    if (!!store.Zrexpress)
      shippingOptions.push({ value: "2", label: "Zr express" });
    if (!!store.Ecotrack && !!store.Uecotrack)
      shippingOptions.push({ value: "3", label: "Ecotrack" });
    if (!!store.Userguid && !!store.ApitokenNord)
      shippingOptions.push({ value: "4", label: "Nord Et Ouest" });
    if (!!store.ecomdelivery_token)
      shippingOptions.push({ value: "14", label: "Ecom Delivery" });
    if (!!store.ecomdeliveryv2_token)
      shippingOptions.push({value:"18",label:"Ecom Delivery V2"});


    return (
      <Dropdown
        overlay={
          <Menu>
            {rowdata?.deleveryStatus !== "5" && (
              <>
                <Menu.Item
                  key="3"
                  className={`ms-33 ss1 bi bi-cart-check ${
                    rowdata?.deleveryStatus === "3" ? "selected" : ""
                  }`}
                  onClick={() => changeStatus(rowData, "3")}
                >
                  <a className="s11">{t("stats.confirmed")}</a>
                </Menu.Item>
                <hr className="m-0 p-0" />
                <Menu.Item
                  key="11-2"
                  className={`ms-33 ss1 bi bi-telephone-x-fill ${
                    rowdata?.deleveryStatus === "11-2" ? "selected" : ""
                  }`}
                  onClick={() => changeStatus(rowData, "11-2")}
                >
                  <a className="s11">{t("stats.status_codes.11-2")}</a>
                </Menu.Item>
                <hr className="m-0 p-0" />
                <Menu.Item
                  key="11-3"
                  className={`ms-33 ss1 bi bi-calendar2-check ${
                    rowdata?.deleveryStatus === "11-3" ? "selected" : ""
                  }`}
                  onClick={() => changeStatus(rowData, "11-3")}
                >
                  <a className="s11">{t("stats.postponed")}</a>
                </Menu.Item>
                <hr className="m-0 p-0" />
                <Menu.Item
                  key="6"
                  className={`ms-33 ss1 bi bi-x-circle ${
                    rowdata?.deleveryStatus === "6" ? "selected" : ""
                  }`}
                  onClick={() => changeStatus(rowData, "6")}
                >
                  <a className="s11">{t("orderDetails.statusOptions.6")}</a>
                </Menu.Item>
                <hr className="m-0 p-0" />
                <Menu.Item
                  key="11-5"
                  className={`ms-33 ss1 bi bi-person-x ${
                    rowdata?.deleveryStatus === "11-5" ? "selected" : ""
                  }`}
                  onClick={() => changeStatus(rowData, "11-5")}
                >
                  <a className="s11">{t("orderDetails.statusOptions.11-5")}</a>
                </Menu.Item>
                <hr className="m-0 p-0" />
                <Menu.Item
                  key="11-1"
                  className={`ms-33 ss1 bi bi-telephone-inbound ${
                    rowdata?.deleveryStatus === "11-1" ? "selected" : ""
                  }`}
                  onClick={() => changeStatus(rowData, "11-1")}
                >
                  <a className="s11">{t("orderDetails.statusOptions.11-1")}</a>
                </Menu.Item>
                <hr className="m-0 p-0" />
                <Menu.Item
                  key="11-4"
                  className={`ms-33 ss1 bi bi-telephone-minus ${
                    rowdata?.deleveryStatus === "11-4" ? "selected" : ""
                  }`}
                  onClick={() => changeStatus(rowData, "11-4")}
                >
                  <a className="s11">{t("stats.status_codes.11-4")}</a>
                </Menu.Item>{" "}
                <hr className="m-0 p-0" />
                <Menu.Item
                  key="4"
                  className={`ms-33 ss1 bi bi-arrow-return-right ${
                    rowData.deleveryStatus === "10" ? "selected" : ""
                  }`}
                  onClick={() => changeStatus(rowData, "10")}
                >
                  <a className="s11">{t("ui.returned")}</a>
                </Menu.Item>
                <hr className="m-0 p-0" />
                {/* إضافة باقي العناصر هنا */}
              </>
            )}
            <Menu.Item
              key="5"
              className={`ms-33 ss1 bi bi-check-circle ${
                rowdata?.deleveryStatus === "5" ? "selected" : ""
              }`}
              onClick={() => changeStatus(rowData, "5")}
            >
              <a className="s11">{t("orders.completed")}</a>
            </Menu.Item>
            {shippingOptions.length > 0 && (
              <>
                <hr className="m-0 p-0" />
                {shippingOptions.map((option) => (
                  <Menu.Item
                    key={option.value}
                    className={`ms-33 ss1 bi bi-truck ${
                      rowData.DC === option.value ? "selected" : ""
                    }`}
                    onClick={() => {
                      changeShip(rowData, option.value);
                    }}
                  >
                    <a className="s11">{t("ui.uploadTo")} {option.label}</a>
                  </Menu.Item>
                ))}
              </>
            )}
          </Menu>
        }
      >
        <button className="flex items-center justify-center py-2.5 border rounded-lg hover:bg-gray-50 duration-150 active:bg-gray-100 bot">
          <img src={buttonImage} style={{ width: "20px" }} alt={t("ui.buttonIcon")} />
        </button>
      </Dropdown>
    );
  };
  let productsToShow = [];
  const product = productdata.find((product) => product.id === data.productId);
  if (from.products && from.products.length > 0) {
    productsToShow = from.products.map((p) =>
      productdata.find((product) => product.id === p.id)
    );
  }
  const [showSubmenus, setShowSubmenus] = useState({});

  // دالة لتبديل حالة العرض للقائمة الفرعية لمنتج معين
  const toggleSubmenu = (products) => {
    setShowSubmenus((prevShowSubmenus) => ({
      ...prevShowSubmenus,
      [products]: !prevShowSubmenus[products],
    }));
  };
  const onDelete = async (product) => {
    try {
      const orderRef = doc(db, "orders", from.id); // استبدل "وثيقة_طلبك" بمعرف الوثيقة الفعلي
      await updateDoc(orderRef, {
        products: arrayRemove(product), // استخدم الكائن الكامل للحذف
      });
    } catch (e) {
      console.error("خطأ عند حذف المنتج: ", e);
    }
  };
  const handleDelete = async (data) => {
    Swal.fire({
      title: t("ship.confirm_delete"),
      text: t("ship.delete_order_prompt"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "rgb(141, 93, 167)",
      cancelButtonColor: "#e87778",
      confirmButtonText: t("ship.yes"),
      cancelButtonText: t("ship.no"),
    }).then((result) => {
      if (result.isConfirmed) {
        const audio = new Audio("/Mouth woosh_42.wav");
        audio.play();

        setDoc(doc(db, "orders", data.id), {
          ...data,
          deleveryStatus: "8",
        }).then(() => {
          window.location.href = "/orders"; // هنا يتم إعادة التوجيه إلى صفحة الطلبات
        });
      }
    });
  };
  return (
    <div className="container-fluid">
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 w-full"
          style={{
            flex: 1,
            backgroundColor: "#fbf8fc",
          }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />
          <div className="m-3 p-0">
            {/*--------------------------------------------------------------------------------*/}
            <div className="">
              <div className="bg-[#5a2b73] w-full h-20 flex justify-center relative rounded-t-lg">
                <div className="absolute top-[10px] flex justify-center">
                  {data.products.map((product) => (
                    <div className="w-24 h-24 rounded-full border-4 border-[#5a2b73] p-1 bg-white">
                      <img
                        className="w-full h-full rounded-full"
                        src={
                          product.image ? product.image : "/product-foorweb.png"
                        }
                        alt={t("ui.profile")}
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div className="mt-8">
                <div className=" " style={{ textAlign: "center" }}>
                  <span className="block text-white1 font-semibold  mx-auto rounded-full">
                    {isFreeCountry ? (
                      <a
                        href={`tel:${from.phone}}`}
                        className=" m-0 text-green-600 font-bold"
                      >
                        {from.phone}
                      </a>
                    ) : data.isValid ? (
                      <i className="fs-3 mb-2">
                        <img className=" mx-auto " src={"/lock.png"} />
                      </i>
                    ) : (
                      <a
                        href={`tel:${from.phone}}`}
                        className=" m-0 text-green-600 font-bold"
                      >
                        {from.phone}
                      </a>
                    )}
                  </span>

                  <p className="text-gray-600 mt-2">{formattedDate}</p>
                </div>
              </div>
              <div className="pt-4  pb-5 flex justify-center  space-x-reverse overflow-hidden">
                <button
                  onClick={
                    !!account.store
                      ? () => handleUpdate(data)
                      : () => {
                          message();
                        }
                  }
                  disabled={data?.isValid}
                  className="flex items-center justify-center py-2.5 border rounded-lg hover:bg-gray-50 duration-150 active:bg-gray-100 bot3"
                >
                  <img src="/faq.png" style={{ width: "20px" }} />
                </button>
                {/* <Dropdown
                                    overlay={
                                        <Menu>

                                            <Menu.Item key="3" className=" ms-33 ss1 bi bi bi-cart-check" onClick={() => changeStatus(from, "3")}>
                                                <a className="s11">مؤكدة</a>
                                            </Menu.Item>  <hr className='m-0 p-0' />
                                            <Menu.Item key="11-2" className=" ms-33 ss1 bi bi-telephone-x-fill" onClick={() => changeStatus(from, "11-2")}>
                                                <a className="s11">لم يرد على الاتصال</a>
                                            </Menu.Item>  <hr className='m-0 p-0' />
                                            <Menu.Item key="11-3" className=" ms-33 ss1 bi bi-calendar2-check" onClick={() => changeStatus(from, "11-3")}>
                                                <a className="s11"> مؤجلة</a>
                                            </Menu.Item>  <hr className='m-0 p-0' />
                                            <Menu.Item key="6" className=" ms-33 ss1 bi bi-x-circle" onClick={() => changeStatus(from, "6")}>
                                                <a className="s11"> ملغي</a>
                                            </Menu.Item>  <hr className='m-0 p-0' />
                                            <Menu.Item key="11-5" className=" ms-33 ss1 bi bi-person-x" onClick={() => changeStatus(from, "11-5")}>
                                                <a className="s11"> ملغى من قبل العميل</a>
                                            </Menu.Item>  <hr className='m-0 p-0' />
                                            <Menu.Item key="11-1" className=" ms-33 ss1 bi bi-telephone-inbound" onClick={() => changeStatus(from, "11-1")}>
                                                <a className="s11">  انتظار اتصال العميل</a>
                                            </Menu.Item>  <hr className='m-0 p-0' />
                                            <Menu.Item key="11-4" className=" ms-33 ss1 bi bi-telephone-minus" onClick={() => changeStatus(from, "11-4")}>
                                                <a className="s11"> الخط مغلق</a>
                                            </Menu.Item>  <hr className='m-0 p-0' />
                                            <Menu.Item key="4" className=" ms-33 ss1 bi bi-truck" onClick={() => changeStatus(from, "4")}>
                                                <a className="s11"> رفع لشركة التوصيل</a>
                                            </Menu.Item>  <hr className='m-0 p-0' />
                                            <Menu.Item key="5" className=" ms-33 ss1 bi-check-circle" onClick={() => changeStatus(from, "5")}>
                                                <a className="s11">مكتملة</a>
                                            </Menu.Item>
                                        </Menu>
                                    }
                                >
                                    <button className="flex items-center justify-center flex items-center justify-center py-2.5 border rounded-lg hover:bg-gray-50 duration-150 active:bg-gray-100 bot3" >
                                        <img src={buttonImage} style={{ width: '20px' }} alt="Button Icon" />
                                    </button>

                                </Dropdown> */}
                <div>
                  {data.isValid ? (
                    <button
                      className="flex items-center justify-center  py-2.5 border rounded-lg hover:bg-gray-50 duration-150 active:bg-gray-100 bot3"
                      onClick={handleTextButtonClick}
                      disabled
                    >
                      <img src="/speech-bubble.png" style={{ width: "20px" }} />
                    </button>
                  ) : (
                    <button
                      className="flex items-center justify-center  py-2.5 border rounded-lg hover:bg-gray-50 duration-150 active:bg-gray-100 bot3"
                      onClick={handleTextButtonClick}
                    >
                      <img src="/speech-bubble.png" style={{ width: "20px" }} />
                    </button>
                  )}
                </div>

                {data.isValid ? (
                  <button
                    className="flex items-center justify-center py-2.5 border rounded-lg hover:bg-gray-50 duration-150 active:bg-gray-100 bot3"
                    onClick={handleCallButtonClick}
                    disabled
                  >
                    <img src="/phone-call.png" style={{ width: "20px" }} />
                  </button>
                ) : (
                  <button
                    className="flex items-center justify-center py-2.5 border rounded-lg hover:bg-gray-50 duration-150 active:bg-gray-100 bot3"
                    onClick={handleCallButtonClick}
                  >
                    <img src="/phone-call.png" style={{ width: "20px" }} />
                  </button>
                )}
                {data.isValid ? (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{t("ship.send_tracking_link")}</Tooltip>}
                  >
                    <button
                      className="flex items-center justify-center py-2.5 border rounded-lg hover:bg-gray-50 duration-150 active:bg-gray-100 bot3"
                      onClick={handleTextButtontrack}
                      disabled
                    >
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/609/609361.png"
                        style={{ width: "20px" }}
                      />
                    </button>
                  </OverlayTrigger>
                ) : (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{t("ship.send_tracking_link")}</Tooltip>}
                  >
                    <button
                      className="flex items-center justify-center py-2.5 border rounded-lg hover:bg-gray-50 duration-150 active:bg-gray-100 bot3"
                      onClick={handleTextButtontrack}
                    >
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/609/609361.png"
                        style={{ width: "20px" }}
                      />
                    </button>
                  </OverlayTrigger>
                )}
              </div>

              {from.nameproduct ? (
                <>
                  {from.products ? (
                    <ul>
                      {data.products.map((product) => (
                        <div
                          className="max-w-2xl mx-auto py-0 md:px-2 relative"
                          key={product.name}
                        >
                          <div
                            className="d-flex justify-content-between w-100 p-1-2 border4 card"
                            onClick={() => toggleSubmenu(product.name)}
                          >
                            <li className="flex gap-4 items-center">
                              <img
                                src={
                                  product.image
                                    ? product.image
                                    : "/product-foorweb.png"
                                }
                                className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                              />
                              <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                                {product.name}
                              </div>
                              <span className="text-sm">
                                {product.price} {localizedCurrency}
                              </span>
                              <i
                                className={`bi ${
                                  showSubmenus[product.name]
                                    ? "bi-chevron-double-up"
                                    : "bi-chevron-double-down"
                                }`}
                                style={{ color: "#45a788" }}
                              ></i>
                            </li>
                          </div>

                          <div
                            className={`submenu ${
                              showSubmenus[product.name] ? "" : "open"
                            }`}
                          >
                            <div className="w-100 p-1-2 border4 ">
                              {product?.options?.offer && (
                                <div className="d-flex justify-content-between w-100 p-1-2-3">
                                  <p className="m-0">{t("orderDetails.product_details.offer")}</p>
                                  <p className="m-0 text-success">
                                    <b>{product?.options?.offer}</b>
                                  </p>
                                </div>
                              )}
                              {product?.options?.offer && (
                                <hr className="m-0 p-0" />
                              )}
                              <div className="d-flex justify-content-between w-100 p-1-2-3">
                                <p className="m-0">{t("orderDetails.product_details.color")}</p>
                                <p className="m-0 text-success">
                                  <b>
                                    <b>
                                      <b>
                                        {typeof product?.options?.color ===
                                          "object" &&
                                        !Array.isArray(product?.options?.color)
                                          ? // إذا كانت `color` كائنًا، اعرض القيم
                                            Object.entries(
                                              product?.options?.color
                                            ).length > 0
                                            ? Object.entries(
                                                product?.options?.color
                                              ).map(([key, value]) => (
                                                <span key={key}>
                                                  {key}:{" "}
                                                  {Array.isArray(value)
                                                    ? value.join(", ")
                                                    : value}
                                                  <br />
                                                </span>
                                              ))
                                            : t("unspecified")
                                          : typeof product?.options?.color ===
                                            "string"
                                          ? // إذا كانت `color` سلسلة نصية، تحقق مما إذا كانت فارغة
                                            product?.options?.color.trim() ===
                                            ""
                                            ? t("unspecified")
                                            : product?.options?.color
                                          : // إذا لم تكن `color` كائنًا ولا سلسلة نصية، اعرض "غير محدد"
                                            t("unspecified")}
                                      </b>
                                    </b>
                                  </b>
                                </p>
                              </div>
                              <hr className="m-0 p-0" />
                              <div className="d-flex justify-content-between w-100 p-1-2-3">
                                <p className="m-0">{t("orderDetails.product_details.option")}</p>
                                <p className="m-0 text-success">
                                  <b>
                                    {typeof product?.options?.size ===
                                      "object" &&
                                    !Array.isArray(product?.options?.color)
                                      ? // !  إذا كانت `color` كائنًا، اعرض القيم
                                        Object.entries(product?.options?.size)
                                          .length > 0
                                        ? Object.entries(
                                            product?.options?.size
                                          ).map(([key, value]) => (
                                            <span key={key}>
                                              {key}:{" "}
                                              {Array.isArray(value)
                                                ? value.join(", ")
                                                : value}
                                              <br />
                                            </span>
                                          ))
                                        : t("unspecified")
                                      : typeof product?.options?.size ===
                                        "string"
                                      ? // !  إذا كانت `color` سلسلة نصية، تحقق مما إذا كانت فارغة
                                        product?.options?.size.trim() === ""
                                        ? t("unspecified")
                                        : product?.options?.size
                                      : // !  إذا لم تكن `color` كائنًا ولا سلسلة نصية، اعرض "غير محدد"
                                        t("unspecified")}
                                  </b>
                                </p>
                              </div>
                              <hr className="m-0 p-0" />
                              <div className="d-flex justify-content-between w-100 p-1-2-3">
                                <p className="m-0">{t("Products.Table.expand.info.quantity")}</p>
                                <p className="m-0 text-success">
                                  <b>{product.quantity}</b>
                                </p>
                              </div>
                            </div>
                          </div>

                          <span
                            className="absolute top-0 left-0 p-1 "
                            style={{
                              backgroundColor: "rgba(69, 167, 77, 0)",
                              marginTop: "-11px",
                            }}
                            onClick={(e) => {
                              e.stopPropagation(); // لمنع تفعيل حدث النقر على المنتج
                            }}
                          >
                            <i
                              onClick={(e) => {
                                data.products.length !== 1
                                  ? onDelete(product)
                                  : handleDelete(data);
                              }}
                              className="bi bi-x-circle"
                              style={{ color: "red", fontSize: "18px" }}
                            ></i>
                          </span>
                        </div>
                      ))}
                    </ul>
                  ) : (
                    <ul>
                      <div className="max-w-2xl mx-auto py-0 md:px-8">
                        <div className="d-flex justify-content-between w-100 p-1-2 border4">
                          <li className="flex gap-4 items-center">
                            <img
                              src={
                                data.image ? data.image : "/product-foorweb.png"
                              }
                              className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                            />
                            <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                              {data.nameproduct}
                            </div>
                            <span className="text-sm">
                              {data.total} {localizedCurrency}
                            </span>
                          </li>
                        </div>
                      </div>
                    </ul>
                  )}
                </>
              ) : data.products ? (
                <ul>
                  {data?.nameproduct
                    ? productsToShow.map((product) => (
                        <div
                          className="max-w-2xl mx-auto py-0 md:px-8"
                          key={product?.id}
                        >
                          <div className="d-flex justify-content-between w-100 p-1-2 border4">
                            <li className="flex gap-4 items-center">
                              <img
                                src={
                                  product?.image
                                    ? product?.image
                                    : "/product-foorweb.png"
                                }
                                className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                              />
                              <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                                {product?.name}
                              </div>
                              <span className="text-sm">
                                {data.total} {localizedCurrency}
                              </span>
                            </li>
                          </div>
                        </div>
                      ))
                    : data.products.map((product, index) => (
                        <div className="max-w-2xl mx-auto py-0 md:px-8">
                          <div className="d-flex justify-content-between w-100 p-1-2 border4">
                            <li className="flex gap-4 items-center">
                              <img
                                src={
                                  product.image
                                    ? product.image
                                    : "/product-foorweb.png"
                                }
                                className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                              />
                              <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                                {product.name}
                              </div>
                              <span className="text-sm">
                                {data.total} {localizedCurrency}
                              </span>
                            </li>
                          </div>
                        </div>
                      ))}
                </ul>
              ) : (
                <ul>
                  <div className="d-flex justify-content-between w-100 p-1-2 border4">
                    <li className="flex gap-4 items-center">
                      <img
                        src={product ? product.image : "/product-foorweb.png"}
                        className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                      />
                      <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                        {product ? product.name : ""}
                      </div>
                      <span className="text-sm">
                        {data.total} {localizedCurrency}
                      </span>
                    </li>
                  </div>
                </ul>
              )}
              <div className="mt-2 grid gap-8 sm:grid-cols-2 lg:grid-cols-2">
                <div className=" justify-content-between w-100 p-1-2 border4 card">
                  <div className="d-flex justify-content-between w-100 p-1-2-3 ">
                    <p className="m-0">{t("orderDetails.customer_info.full_name")} </p>
                    <p className="m-0 text-success">
                      <b>{from.name} </b>
                    </p>
                  </div>
                  <hr className="m-0 p-0" />
                  <div className="d-flex justify-content-between w-100 p-1-2-3 ">
                    <p className="m-0">{t("orderDetails.customer_info.phone_number")} </p>
                    <p className="m-0 text-success">
                      <b>
                        {isFreeCountry ? (
                          <a
                            href={`tel:${from.phone}}`}
                            className=" m-0 text-green-600 font-bold"
                          >
                            {from.phone}
                          </a>
                        ) : data.isValid ? (
                          <i className="fs-3 mb-2">
                            <img className=" mx-auto " src={"/lock.png"} />
                          </i>
                        ) : (
                          <a
                            href={`tel:${from.phone}}`}
                            className=" m-0 text-green-600 font-bold"
                          >
                            {from.phone}
                          </a>
                        )}
                      </b>
                    </p>
                  </div>
                  <hr className="m-0 p-0" />
                  <div className="d-flex justify-content-between w-100 p-1-2-3 ">
                    <p className="m-0">{t("orderDetails.customer_info.full_address")} </p>
                    <p className="m-0 text-success">
                      <b>
                        {from.state}.{from.commune}.{from.address}{" "}
                      </b>
                    </p>
                  </div>
                  <hr className="m-0 p-0" />
                  <div className="d-flex justify-content-between w-100 p-1-2-3 ">
                    <p className="m-0">{t("orderDetails.customer_info.customer_note")} </p>
                    <p className="m-0 text-success">
                      <b>
                        {from.note.trim() !== "" || from.options.trim() !== ""
                          ? from.note.trim() || from.options.trim()
                          : t("ship.no_note")}
                      </b>
                    </p>
                  </div>
                </div>
                <div className=" justify-content-between w-100 p-1-2 border4 card">
                  <div className="d-flex justify-content-between w-100 p-1-2-3 ">
                    <p className="m-0"> {t("orderDetails.order_summary.product_value")}</p>
                    <p className="m-0 text-success">
                      <b>
                        {data.total} {localizedCurrency}
                      </b>
                    </p>
                  </div>
                  <hr className="m-0 p-0" />
                  <div className="d-flex justify-content-between w-100 p-1-2-3 ">
                    <p className="m-0">{t("orderDetails.order_summary.quantity")}</p>
                    <p className="m-0 text-success">
                      <b> {data.qty} </b>
                    </p>
                  </div>
                  <hr className="m-0 p-0" />
                  <div className="d-flex justify-content-between w-100 p-1-2-3 ">
                    <p className="m-0">{t("orderDetails.order_summary.delivery")}</p>
                    <p className="m-0 text-success">
                      <b>
                        {data.deleveryPrice
                          ? data.deleveryPrice
                          : data.deliveryPrice}{" "}
                        {localizedCurrency}
                      </b>
                    </p>
                  </div>
                  <hr className="m-0 p-0" />
                  <div className="d-flex justify-content-between w-100 p-1-2-3 ">
                    <p className="m-0">{t("orderDetails.order_summary.total")}</p>
                    <p className="m-0 text-success">
                      <b>
                        {data.total +
                          (data.deleveryPrice
                            ? data.deleveryPrice
                            : data.deliveryPrice)}{" "}
                        {localizedCurrency}
                      </b>
                    </p>
                  </div>
                </div>{" "}
              </div>
              {/*-------------------------------------------------------------------------------*/}

              {/*---------------------------------------------------------------------------------------------------------------- */}
              <div className="row">
                {/*-------------------------------------------------------------------------------*/}
                <div className="mt-12 ">
                  <p className="text-gray-600 text-xl font-semibold sm:text-s">
                    {t("orderDetails.order_status_history.title")}
                  </p>
                  <ul className="grid gap-8 sm:grid-cols-1 lg:grid-cols-1">
                    {data.statusTimeline ? (
                      data.statusTimeline.reverse().map((statusUpdate, idx) => (
                        <li
                          key={idx}
                          className="flex gap-4 items-center border4 "
                          style={{
                            marginBottom: "-27px",
                            backgroundColor: "#fff",
                          }}
                        >
                          <div className="flex-none w-24 h-24 ">
                            <img
                              src={
                                statusUpdate.status === "1"
                                  ? "   https://cdn-icons-png.flaticon.com/512/10608/10608900.png "
                                  : statusUpdate.status === "2"
                                  ? "https://cdn-icons-png.flaticon.com/128/1688/1688988.png"
                                  : statusUpdate.status === "3"
                                  ? "https://cdn-icons-png.flaticon.com/128/6815/6815043.png"
                                  : statusUpdate.status === "4"
                                  ? "https://cdn-icons-png.flaticon.com/128/1559/1559859.png"
                                  : statusUpdate.status === "5"
                                  ? "https://cdn-icons-png.flaticon.com/128/6815/6815043.png"
                                  : statusUpdate.status === "6"
                                  ? "https://cdn-icons-png.flaticon.com/128/391/391247.png"
                                  : statusUpdate.status === "11-1"
                                  ? "https://cdn-icons-png.flaticon.com/128/2593/2593514.png"
                                  : statusUpdate.status === "11-2"
                                  ? "https://cdn-icons-png.flaticon.com/128/9946/9946401.png"
                                  : statusUpdate.status === "11-3"
                                  ? "../agenda.png"
                                  : statusUpdate.status === "11-4"
                                  ? "https://cdn-icons-png.flaticon.com/128/8402/8402548.png"
                                  : statusUpdate.status === "11-5"
                                  ? "https://cdn-icons-png.flaticon.com/128/7787/7787073.png"
                                  : "https://cdn-icons-png.flaticon.com/128/11442/11442042.png" // الصورة الافتراضية
                              }
                              className="w-full h-full rounded-full"
                              alt=""
                              style={{
                                width: "35px",
                                height: "35px",
                                margin: "20px",
                              }}
                            />
                          </div>
                          <div>
                            <h4 className=" font-semibold sm:text-lg">
                              {getStatusText(statusUpdate.status)}
                            </h4>
                            <p
                              className="text-[#9e68ba]"
                              style={{ marginBottom: "0px !important" }}
                            >
                              {format(
                                new Date(statusUpdate.timestamp.seconds * 1000),
                                "yyyy-MM-dd HH:mm:ss"
                              )}
                            </p>
                          </div>
                        </li>
                      ))
                    ) : (
                      <li className=""></li>
                    )}
                    <li
                      className="flex gap-4 items-center border4 "
                      style={{ marginBottom: "-27px", backgroundColor: "#fff" }}
                    >
                      <div className="flex-none w-24 h-24 ">
                        <img
                          src={
                            "https://cdn-icons-png.flaticon.com/512/10608/10608900.png"
                          }
                          className="w-full h-full rounded-full"
                          alt=""
                          style={{
                            width: "35px",
                            height: "35px",
                            margin: "20px",
                          }}
                        />
                      </div>
                      <div>
                        <h4 className=" font-semibold sm:text-lg">
                          {t("ship.order_received")}
                        </h4>
                        <p className="text-[#9e68ba]">{formattedDate}</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <ModalAdd
            lgShow={showModal}
            setLgShow={setShowModal}
            dataForm={dataForm}
            setDataForm={setDataForm}
            data={data ? [data] : []}
          />

          <Footer />
        </div>
      </div>
    </div>
  );
}

export default OrderDetailsabndn;
